<template>
    <el-container class="info">
      <!-- el-main -->
        <el-main class="mains">
            <div class="newinfo">
                <div class="newbox">

                    <!-- 所有header都是首页跳转过来的实验，header2都是点击切换后的实验 -->
                    <!-- <div class="headerinfo" v-if="header">
                        <ul>
                            <li>{{infoTitle}}</li>
                            <li>
                                <el-tooltip class="item" effect="dark" v-if="previous.title" :content="previous.title" placement="top">
                                    <el-button type="text" style="font-size:16px;color: #999999;font-weight:bold;margin-top:18px;" @click="backinfo">上一个实验&nbsp;&nbsp;/</el-button>
                                </el-tooltip>
                            </li>
                            <li>
                                <el-tooltip class="item" effect="dark" v-if="next.title" :content="next.title" placement="top">
                                    <el-button type="text" style="font-size:16px;color: #999999;font-weight:bold;margin-top:18px;" @click="upinfo">&nbsp;下一个实验</el-button>
                                </el-tooltip>
                            </li>
                        </ul>
                        <ol>
                            <li>
                                <div class="tokra2">
                                    <el-rate
                                        disabled
                                        disabled-void-color="#c8c8c8"
                                        v-model="infoAerage"
                                        text-color="#ff9900"
                                        >
                                    </el-rate>
                                </div>
                            </li>
                            <li>
                                <span class="toke">共有&nbsp;&nbsp;<b style="color:#EEA236">{{infoScoringMan}}</b>&nbsp;&nbsp;人参与评分</span>
                            </li>
                        </ol>
                        <p class="breakB">
                            <el-breadcrumb separator="/">
                                <el-tooltip class="item" effect="dark" content="返回该路径" placement="top">
                                    <el-breadcrumb-item :to="{ path: '/' }">返回</el-breadcrumb-item>
                                </el-tooltip>
                                <el-breadcrumb-item ><span style="font-weight:bold">{{infoNodeName}}</span></el-breadcrumb-item>
                            </el-breadcrumb>
                        </p>
                    </div> -->
                    <el-row>
                        <el-col :xs="24" :sm="24" :lg="24" :xl="24">
                            <div class="headerinfo" v-if="header2">
                                <ul>
                                    <li>{{newup.title}}</li>
                                    <li>
                                        <el-tooltip class="item" effect="light" v-if="previous.title" :popper-class="toolTipClass" :content="previous.title" placement="top" :open-delay="200">
                                            <el-button type="text" style="font-size:16px;color: #999999;font-weight:bold;margin-top:18px;" @click="backinfo2">上一个实验&nbsp;&nbsp;/</el-button>
                                        </el-tooltip>
                                    </li>
                                    <li>
                                        <el-tooltip class="item" effect="light" v-if="next.title" :popper-class="toolTipClass" :content="next.title" placement="top" :open-delay="200">
                                            <el-button type="text" style="font-size:16px;color: #999999;font-weight:bold;margin-top:18px;" @click="upinfo2">&nbsp;下一个实验</el-button>
                                        </el-tooltip>
                                    </li>
                                </ul>
                                <!-- <ol>
                                    <li>
                                        <div class="tokra2">
                                            <el-rate
                                                disabled
                                                disabled-void-color="#c8c8c8"
                                                v-model="infoAerage"
                                                text-color="#ff9900"
                                                >
                                            </el-rate>
                                        </div>
                                    </li>
                                    <li>
                                        <span class="toke">共有&nbsp;&nbsp;<b style="color:#EEA236">{{infoScoringMan}}</b>&nbsp;&nbsp;人参与评分</span>
                                    </li>
                                </ol> -->
                                <p class="breakB">
                                    <el-breadcrumb separator="/">
                                        <!-- <el-tooltip class="item" effect="dark" content="返回此路径" placement="top"> -->
                                            <el-breadcrumb-item :to="{ path: '/synchronization' , replace: true}"><i class="el-icon-back"></i> 返回</el-breadcrumb-item>
                                        <!-- </el-tooltip> -->
                                        <!-- <el-breadcrumb-item ><span style="font-weight:bold">{{infoNodeName}}</span></el-breadcrumb-item> -->
                                    </el-breadcrumb>
                                </p>
                                <div class="joinTrue" v-if="this.newup.collect == 1 && this.newup.isStudy == 0">已收藏</div>
                                <div class="joinMyEx" @click="joinEx()" v-else>收藏到我的实验</div>
                            </div>
                        </el-col>
                        <el-col :xs="24" :sm="24" :lg="24" :xl="24">
                        <!-- <div class="newclassification" v-if="header" v-loading="loading">
                            <el-button type="primary" class="bottonyijian" @click="yijianblock" style="z-index:1000;position:absolute;right:0;">意见反馈</el-button>
                            <el-tabs type="card">
                                <el-tab-pane :label="item.noticeTitle" v-for="(item,index) in Information" :key="index" class="tabinfo">
                                    <div class="boxss">
                                        <div class="boxs"></div>
                                        <div v-html="item.noticeTitle" class="infotitle2"></div>
                                        <div v-html="item.noticeInfo" class="noinfo"></div>
                                    </div>
                                    <div class="imginfo">
                                        <p class="upstrata" v-if="video"><el-button type="text" class="el-icon-switch-button" @click="getGame"></el-button></p>
                                        <img :src="infoPhoto" alt="">
                                    </div>
                                </el-tab-pane>
                            </el-tabs>
                        </div> -->
                            <div class="newclassification" v-if="header2" v-loading="loading">
                                <el-button type="primary" class="bottonyijian" @click="yijianblock" style="z-index:1000;position:absolute;right:0;">意见反馈</el-button>
                                <el-tabs type="card">
                                    <el-tab-pane :label="item.noticeTitle" v-for="(item,index) in Information2" :key="index" class="tabinfo">
                                        <el-row style="margin:34px 12px" :gutter="36">
                                            <el-col :xs="12" :sm="12" :lg="12" :xl="12">
                                                <div class="brief">
                                                    <div class="boxs"></div>
                                                    <div v-html="item.noticeTitle" class="infotitle2"></div>
                                                    <div v-html="item.noticeInfo" class="noinfo"></div>
                                                </div>
                                            </el-col>
                                            <el-col :xs="12" :sm="12" :lg="12" :xl="12">
                                                <div class="imginfo">
                                                    <p class="blackbox"></p>
                                                    <div class="upstrata-box">
                                                        <p class="upstrataO" v-if="videos == 0"><el-button type="text" class="startgame" @click="getGame">开始实验</el-button></p><br v-if="videos == 0">
                                                        <p class="upstrata" v-if="videos == 1"><el-button type="text" class="startgame" @click="getGame">开始实验</el-button></p><br v-if="videos == 1">
                                                        <p class="upstrataS" v-if="0 == 1"><el-button type="text" class="startgameS" @click="getExVideo">观看视频</el-button></p>
                                                    </div>
                                                    <img :src="newup.fileThumbnail" alt="">
                                                </div>
                                            </el-col>
                                        </el-row>
                                    </el-tab-pane>
                                </el-tabs>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
                    <!-- <iframe id="ifrunity" frameborder=0 scrolling=auto allowtransparency="true" :src="'http://127.0.0.1:8093/WebSite/syplay.html?'+'UID='+experimentuid+'&Authorization='+$store.state.user.token+'&SyName='+experimentcode"></iframe> -->
            <!-- FWQunity -->
            <div id="unitybox" v-if="unityex">
                <div id="bo">
                <div id="buttombox" v-if="isPad">
                    <el-tooltip class="item" effect="light" :popper-class="toolTipClass" content="关闭实验" placement="right" :open-delay="200">
                        <p id="closeun" @click="closeuni" style="cursor: pointer;float:left"><i><img src="../../../assets/images/portal/close.png" alt=""></i></p>
                    </el-tooltip>
                    <el-tooltip class="item" effect="light" :popper-class="toolTipClass" content="全屏显示" placement="right" :open-delay="200">
                        <div id="full" @click="fullSrc" style="cursor: pointer;float:left"><i><img src="../../../assets/images/portal/full.png" alt=""></i></div>
                    </el-tooltip>
                </div>
                <div id="buttombox" v-if="isPad2">
                    <p id="closeun" @click="closeuni" style="cursor: pointer;float:left"><i><img src="../../../assets/images/portal/close.png" alt=""></i></p>
                </div>
                    <iframe id="ifrunity" frameborder=0 scrolling=auto allowtransparency="true" :src=" this.resourceURL +'?'+'UID='+this.experimentuid+'&Authorization='+$store.state.user.token+'&SyName='+this.experimentcode+'&config='+this.config+'&resourceid='+this.infoId"></iframe>
                </div>
            </div>
            <div id="unitybox" v-if="videoEx">
                <div id="bo">
                <div id="buttombox" v-if="isPad">
                        <p id="closeunV" @click="closeV" style="cursor: pointer;float:left"><i><img src="../../../assets/images/portal/close.png" alt=""></i></p>
                </div>
                <div id="buttombox" v-if="isPad2">
                    <p id="closeun" @click="closeV" style="cursor: pointer;float:left"><i><img src="../../../assets/images/portal/close.png" alt=""></i></p>
                </div>
                    <div class='demo'>
                        <video :id="'m3u8'+this.modalvideo.id" class="video-js" preload="auto" v-if="vshow">
                            <source :src="this.modalvideo.videom3u8path" type="application/x-mpegURL">
                        </video>
                    </div>
                </div>
            </div>
            <!-- BDunity -->
            <!-- <div class="unitybox" v-show="iscloseE" v-if="experimentcode">
                    <p class="el-icon-close" @click="closeE"></p>
                    <unity src="../../../../static/WebGL_Discovery/Build/WebGL_Discovery.json" style="width:1000px;height:600px;position:absolute;left:50%;top:50%;transform: translateX(-50%) translateY(-50%);" unityLoader="../../../../static/phy_chu_001/Build/UnityLoader.js" id="unitys"></unity>
            </div> -->
            <!-- 'http://221.231.139.161:8093/SYData/phy_chu/'+experimentcode+'/Build/'+experimentcode+'.json'  v-if="experimentcode"-->
            <!-- <unity :src="'http://221.231.139.161:8093/SYData/phy_chu/'+experimentcode+'/Build/'+experimentcode+'.json'" style="width:1000px;height:600px;position:absolute;left:50%;top:50%;transform: translateX(-50%) translateY(-50%);" unityLoader="../../../../static/phy_chu_008/Build/UnityLoader.js" ref="myInstance"></unity> -->
            <!-- <div id="box"> -->
                <!-- 底部评分栏 -->
                <!-- <el-footer style="height:auto;padding-bottom:32px;">
                        <div class="foot">
                            <div class="comment" v-if="header">
                                <p>评分</p>
                                <div class="tokra">
                                    <el-rate
                                        v-model="infoAerage"
                                        text-color="#ff9900"
                                        @change="changerate">
                                    </el-rate>
                                    <span class="toke">共有<b style="color:#EEA236">&nbsp;&nbsp;{{infoScoringMan}}</b>&nbsp;&nbsp;人参与评分</span>
                                </div>
                            </div>
                            <div class="comment" v-if="header2">
                                <p>评分</p>
                                <div class="tokra">
                                    <el-rate
                                        v-model="infoAerage"
                                        text-color="#ff9900"
                                        @change="changerate">
                                    </el-rate>
                                    <span class="toke">共有<b style="color:#EEA236">&nbsp;&nbsp;{{infoScoringMan}}</b>&nbsp;&nbsp;人参与评分</span>
                                </div>
                            </div>
                            <!-- 评论 -->
                            <!-- <div class="chat" v-if="header">
                                <el-form ref="form" :model="comment">
                                    <el-form-item label="">
                                        <el-input type="textarea" :rows="6" v-model="comment.msg" placeholder="参与互动交流，与大家伙探讨知识，分享经验"></el-input>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-button type="primary" @click="onSubmit">立即发表</el-button>
                                    </el-form-item>
                                </el-form>
                            </div>
                            <div class="chat" v-if="header2">
                                <el-form ref="form" :model="comment">
                                    <el-form-item label="">
                                        <el-input type="textarea" :rows="6" v-model="comment.msg" placeholder="参与互动交流，与大家伙探讨知识，分享经验"></el-input>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-button type="primary" @click="onSubmit">立即发表</el-button>
                                    </el-form-item>
                                </el-form>
                            </div> -->
                        <!-- </div> -->
                <!-- </el-footer> -->
                <!-- 评论展示 -->
                <!-- <div class="commentshow" v-if="header">
                    <div class="show">评论展示</div>
                    <div class="noshow" v-if="labshow==''">
                        <p><img src="../../../assets/images/portal/nosearch.png" alt=""></p>
                        <span>暂无评论</span>
                    </div>
                    <div class="labshow" v-for="(item,index) in labshow" :key='index'>
                        <dl>
                            <dt><img :src="item.avatar" alt=""></dt>
                            <dd><timeago :datetime="item.edittime" locale="zh-CN"></timeago></dd>
                            <dd v-html="item.msg" :title="item.msg"></dd>
                        </dl>
                        <p v-html="item.username"></p>
                    </div>
                    <div class="paginations">
                        <el-pagination
                            background
                            hide-on-single-page
                            layout="prev, pager, next"
                            :total="pageData.total"
                            @current-change="pageChange"
                            :page-size='5'
                            >
                        </el-pagination>
                    </div>
                </div>
                <div class="commentshow" v-if="header2">
                    <div class="show">评论展示</div>
                    <div class="noshow" v-if="labshow==''">
                        <p><img src="../../../assets/images/portal/nosearch.png" alt=""></p>
                        <span>暂无评论</span>
                    </div>
                    <div class="labshow" v-for="(item,index) in labshow" :key='index'>
                        <dl>
                            <dt><img :src="item.avatar" alt=""></dt>
                            <dd><timeago :datetime="item.edittime" locale="zh-CN"></timeago></dd>
                            <dd v-html="item.msg"></dd>
                        </dl>
                        <p v-html="item.username"></p>
                    </div>
                    <div class="paginations">
                        <el-pagination
                            background
                            hide-on-single-page
                            layout="prev, pager, next"
                            :total="pageData.total"
                            @current-change="pageChange"
                            :page-size='5'
                            >
                        </el-pagination>
                    </div>
                </div> -->
            <!-- </div> -->
            <div id="el-main-footer">
                <span>淄博市教育局</span>
                <span> ⋅ </span>
                <a href="http://www.beian.miit.gov.cn" target="_blank">鲁ICP备19014450号-9</a>
                 
            </div>
        </el-main>
        <div class="out" v-if="flagb">
           <div class="feedback">
               <p>意见反馈<span @click="closeb" class="clo"><img src="../../../assets/images/newimg/close.png" alt=""></span></p>
                <div>
                       <el-input
                        type="textarea"
                        :rows="9"
                        placeholder="我们会非常重视您的反馈，请认真填写。"
                        v-model="Feedback"
                        maxlength="500"
                        show-word-limit>
                       </el-input>
                </div>
                <ol>
                    <li><el-button class="up" @click="upfeedback">确定</el-button></li>
                </ol>
           </div>
        </div>
    </el-container>
</template>


<script>
import request from '@/utils/request'
import TimeRoles from '@/api/time.js'
// import formatDate from '@/api/fortime.js'
import { Message } from 'vue-unity-webgl';
// unity
import Unity from 'vue-unity-webgl'

import videojs from 'video.js';
import 'videojs-contrib-hls';
import 'videojs-markers';

export default {
    // name:'Binfo',
    data() {
      return {
        isPad:true,
        isPad2:false,
        vshow:false,
        modalvideo:{
            videom3u8path:'',
            id:'',
            videopic:'',
            markersView:[]
        },
        treeIds:[],
        chapterIds:[],
        videoEx:false,
        videos:'',
        videoUrl:'',
        //tooltip提示文字
        toolTipClass: 'page-login-toolTipClass',
        // 上一个
        next:{},
        // 下一个
        previous:{},
        config:'',
        unityex:false,
        userid:0,
        localinfo:'',
        video:true,
        startTimer: '',
        startTimer2: '',
        endTimer: '',
        endTimer2: '',
        mi:'',
        // 关闭
        iscloseE:false,
        experimentcode:"",
        experimentidx:"",
        experimenttit:"",
        experimentuid:"",
        excontent:'',
        loading:false,
        header:false,
        header2:true,
        resourceURL:'',
        // getinfos:0,
        usinfo:'',
        //下一个实验
        newup:{
            average:0
        },
        eduId:'',
        //分页
        pageData:{
            pagesize:5,
            pagenumber:0,
            total:0
        },
        //实验展示存储
        labshow:{},
        radio2: 1,
        adress:'',
        phone:'',
        Feedback:'',
        checkListfeed:0,
        //评分
        score:{
            fraction: 0,
            scoreMan: 0,
            totalPoints: 0,
        },
        comment:{
            fraction: 0,
            edittime: 0,
            username:"",
            msg:'',
        },
        Information:[{}],
        Information2:[{}],
        infoId:'',
        infoTitle:'',
        infoPhoto:'',
        infoNumber:'',
        infoTreeId:0,
        localinfo:'',
        infoAerage:0,
        infoNodeName:'',
        infoIsFree:0,
        infoSearch:'',
        infoScoringMan:0,
        infoTotalPoints:0,
        infoStudy:0,
        infoBrowseNum:0,
        checkList: ['实验操作复杂'],
        textarea: '',
        flagb:false,
        // flago:false,
        imageUrl: '',
        switchs:'探究',
        codeNum:'',
        timeType:'',
      };
    },
    components: {
        Unity
    },
    created(){
        this.getIndex();
        this.commentshow();
        this.getinfo();
        this.getExperiment();
        this.getinfoex();
        this.getConfig();
    },
    mounted(){
        // this.getInformation();
        this.browseNum();
    },
    computed:{
        isexcode:function(){
            let ph = this.experimentcode
            let last = ph.lastIndexOf('_')
            return ph.substring(0,last)
        },
        breadcrumb(){
          return  this.$route.meta.breadcrumb;
        }
    },
    beforeRouteLeave(to, from, next) {
      if (to.path == "/synchronization") {
        to.meta.keepAlive = true;
      } else {
        to.meta.keepAlive = false;
      }
        next();
    },
    // destroyed () {
    //     this.videoPlayer.dispose()
    // },
    methods:{
        // 初始化视频
        Initialization(){
            this.$nextTick(() => {
                this.videoPlayer = videojs('m3u8'+this.modalvideo.id, {
                //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
                controls: true,
                //自动播放属性,muted:静音播放
                autoplay: "false",
                //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
                preload: "auto",
                poster: this.modalvideo.videopic
                })
                this.videoPlayer.markers({
                    markerStyle: {
                        'width': '8px',
                        'background-color': '#2174ff'
                    },
                    markers: this.modalvideo.markersView,
                    markerTip: {
                        display: true,
                        text: function (marker) {
                        return  marker.text;
                        }
                    },
                    onMarkerReached: function (marker) {
                    }
                });
                videojs('m3u8'+this.modalvideo.id).pause();
            });
        },
        // 详情收藏我的实验
        joinEx(){
            this.$confirm('您是否要将此实验收藏到 我的实验？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            cancelButtonClass: 'messageBox-btnF',
            confirmButtonClass: 'messageBox-btnT',
            type: 'warning',
            }).then(() => {
                request({
                    method:'post',
                    url:'api/updateUserCollect?'+'resourcesId='+this.infoId+'&userId='+this.userid+'&chapterIds='+this.chapterIds+'&treeIds='+this.treeIds
                }).then(res=>{
                    this.getinfoex();
                })
            }).catch(() => {
            });
        },
        // 获取实验视频信息
        getExVideo(){
            request({
                method:'get',
                url:'api/searchJdVideosById?id='+this.infoId
            }).then(res=>{
                this.videos = 1
                this.modalvideo.videom3u8path = res.data.video.videom3upath
                this.modalvideo.id = res.data.video.id
                this.modalvideo.videopic = res.data.video.videopic
                this.templist = []
                res.data.point.forEach(item=>{
                    const itList = {time: item.pointtime, text: item.pointname,info:item.pointinfo};
                    this.templist.push(itList);
                });
                this.modalvideo.markersView = this.templist;
                this.videoEx = true;
                this.vshow = true;
                this.Initialization();
                if(document.body.clientWidth < 1024){
                    this.isPad2 = true;
                    this.isPad = false;
                }
            })
        },
        // 关闭视频
        closeV(){
            this.videoEx = false;
            this.vshow = false;
            this.videoPlayer.dispose();
        },
        // 获取是否是详情页
        isinfo(){
            this.bus.$emit("isinfo", 1)
        },
        // 获取config信息
        getConfig(){
            request({
                method:'get',
                url:'api/getConfiguration?'+'version=v1.1'
            }).then(res=>{
                if(res.code == 200){
                    this.config = res.data
                }else{
                    this.$notify({
                        message: 'config获取失败',
                        type: 'error',
                        duration: 1500
                    })
                }
            })
        },
        // 获取所有详细信息
        getinfoex(){
            this.loading = true
            request({
                method:'get',
                url:'api/jdResources/'+this.infoId+'?isStudy='+this.infoStudy
            }).then(res=>{
                if(res.data.isVideo == true){
                    this.videos = 1
                }else{
                    this.videos = 0
                }
                this.newup = res.data.jdresource
                this.infoAerage = res.data.jdresource.average
                this.infoTotalPoints = res.data.jdresource.totalPoints
                this.infoScoringMan = res.data.jdresource.scoringMan
                this.Information2 = res.data.jdInformation
                this.resourceURL = res.data.resourceURL
                // 获取知识点
                this.treeIds = []
                for(let i in res.data.Tree){
                    this.treeIds.push(res.data.Tree[i].id)
                }
                // 获取章节
                this.chapterIds = []
                for(let i in res.data.jdchaptertree){
                    this.chapterIds.push(res.data.jdchaptertree[i].id)
                }
                this.loading = false
            })
        },
        // 上一个实验
        backinfo2(){
            this.loading = true
            this.newup.fileThumbnail = ''
            request({
                method:'get',
                url:'api/jdResources/'+this.previous.id+'?isStudy='+this.infoStudy
            }).then(res=>{
                if(res.data.isVideo == true){
                    this.videos = 1
                }else{
                    this.videos = 0
                }
                this.infoId = res.data.jdresource.id
                this.newup = res.data.jdresource
                this.infoAerage = res.data.jdresource.average
                this.infoTotalPoints = res.data.jdresource.totalPoints
                this.infoScoringMan = res.data.jdresource.scoringMan
                this.Information2 = res.data.jdInformation
                this.resourceURL = res.data.resourceURL
                this.loading = false
                this.getlastorpre()
                this.getExperiment();
            })
        },
        // 下一个实验
        upinfo2(){
            this.loading = true
            this.newup.fileThumbnail = ''
            request({
                method:'get',
                url:'api/jdResources/'+this.next.id+'?isStudy='+this.infoStudy
            }).then(res=>{
                if(res.data.isVideo == true){
                    this.videos = 1
                }else{
                    this.videos = 0
                }
                this.infoId = res.data.jdresource.id
                this.newup = res.data.jdresource
                this.infoAerage = res.data.jdresource.average
                this.infoTotalPoints = res.data.jdresource.totalPoints
                this.infoScoringMan = res.data.jdresource.scoringMan
                this.Information2 = res.data.jdInformation
                this.resourceURL = res.data.resourceURL
                this.loading = false
                this.getlastorpre()
                this.getExperiment();
            })
        },
        // 获取上一个/下一个实验信息
        getlastorpre(){
            request({
                method:'post',
                url:'api/findPrevOrNextResource?'+'collectFees='+this.infoIsFree+'&eduTreeIds='+this.infoTreeId+'&id='+this.infoId+'&shelves=1'+'&title='+this.infoSearch+'&treetype='+this.infoNumber+'&sort=stick%2Cdesc'+'&size=10000'+'&userCollect=0'+'&userId='+this.userid+'&isStudy=0'
            }).then(res=>{
                this.next = res.data.Next
                this.previous = res.data.previous
            })
        },
        // 全屏显示
        fullSrc(element){
            var element = document.getElementById("ifrunity");
            if(element.requestFullscreen){
                return element.requestFullscreen();
            }else if(element.webkitRequestFullScreen){
                return element.webkitRequestFullScreen();
            }else if(element.mozRequestFullScreen){
                return element.mozRequestFullScreen();
            }else{
                return element.msRequestFullscreen();
            }
            // var element = document.getElementById("ifrunity");
            // element.requestFullscreen();
        },
        // 关闭实验
        closeuni(){
            this.$confirm('此操作将关闭当前实验, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                cancelButtonClass: 'messageBox-btnF',
                confirmButtonClass: 'messageBox-btnT',
                type: 'warning',
            }).then(() => {
                this.unityex = false;
                this.timeType = 1
                this.getExIntervalTime();
            }).catch(() => {
                this.unityex = true;
            })
        },
        //实验存放
        getExperiment(){
            this.loading = true
            this.experimentcode = null
            request({
                method:'get',
                url:'api/jdAppList/'+this.infoId
            }).then(res=>{
                this.loading = false
                this.experimenttit = res.data.obj.title
                this.experimentcode = res.data.obj.code
                this.experimentidx = res.data.obj.appIDX
                this.experimentuid = res.data.obj.uid
                this.video = true
                // document.getElementById("unitys").src = 'http://221.231.139.161:8093/SYData/phy_chu/'+experimentcode+'/Build/'+experimentcode+'.json'
            })
        },
        randomString(len) {
        　　len = len || 32;
            let $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
        　　let maxPos = $chars.length;
        　　let pwd = '';
        　　for (let i = 0; i < len; i++) {
        　　　　pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
        　　}
            this.codeNum = pwd
            if(this.codeNum !== ''){
                this.timeType = 0
                this.getExIntervalTime();
            }
        },
        getExIntervalTime(){
            request({
                url:"api/resourcePlay?code="+this.codeNum+"&resourceid="+this.infoId+"&type="+this.timeType,
                method:"post"
            }).then(res=>{
            })
        },
        // 点击显示实验
        getGame(){
            if(this.experimentcode == '' || this.experimentcode == null){
              this.$notify({
                  message: '实验code为空，请联系管理员',
                  type: 'error',
                  duration: 1500
              })
            }else if(this.experimentuid == '' || this.experimentuid == null){
              this.$notify({
                  message: '实验uid为空，请联系管理员',
                  type: 'error',
                  duration: 1500
              })
            }else{
                this.randomString(32);
                this.unityex = true
                if(document.body.clientWidth < 1024){
                    this.isPad2 = true;
                    this.isPad = false;
                }
            }
        },
        closeE(){
            this.iscloseE = false
        },
        //意见反馈
        yijianblock(){
            this.flagb = true
        },
        //获取到info
        getinfo(){
          request({
            method:'get',
            url:'auth/info'
          }).then(res=>{
            this.userid = res.jwtUser.id
            this.usinfo = res.jwtUser.avatar
            this.getlastorpre();
            // this.getinfos = res.us.edu_treeid
          })
        },
        getinfo2(){
          request({
            method:'get',
            url:'auth/info'
          }).then(res=>{
            this.userid = res.jwtUser.id
            this.usinfo = res.jwtUser.avatar
            this.getlastorpre();
            // this.getinfos = res.us.edu_treeid
          })
        },
        //点击左边上一个实验
        // backinfo(){
        //     this.loading = true
        //     this.header = false
        //     this.header2 = true
        //     this.experimentcode = false
        //     // this.ExperimentUnity();
        //     request({
        //         method:'post',
        //         url:'api/findPrevOrNextResource?'+'id='+this.infoId+'&eduTreeIds='+this.infoTreeId+'&res=0'+'&treetype='+this.infoNumber
        //     }).then(res=>{
        //         this.infoId = res.data.jdresources.id
        //         this.newup = res.data.jdresources
        //         this.infoAerage = res.data.jdresources.average
        //         this.infoScoringMan = res.data.jdresources.scoringMan
        //         this.Information2 = res.data.attr
        //         this.labshow = res.data.comment.content;
        //         this.commentshow();
        //         this.loading = false
        //         this.getExperiment();
        //     }).catch(err=>{
        //         this.$notify({
        //             message:"暂无实验,我们会尽快补充,已为您跳转首页",
        //             type:'error'
        //         })
        //         this.$router.push('/')
        //     })
        // },
        //点击右边下一个实验
        // upinfo(){
        //     this.loading = true
        //     this.header = false
        //     this.header2 = true
        //     this.experimentcode = false
        //     // this.ExperimentUnity();
        //     request({
        //         method:'post',
        //         url:'api/findPrevOrNextResource?'+'id='+this.infoId+'&eduTreeIds='+this.infoTreeId+'&res=1'+'&treetype='+this.infoNumber
        //     }).then(res=>{
        //         this.infoId = res.data.jdresources.id
        //         this.newup = res.data.jdresources
        //         this.infoAerage = res.data.jdresources.average
        //         this.infoScoringMan = res.data.jdresources.scoringMan
        //         this.Information2 = res.data.attr
        //         this.labshow = res.data.comment.content;
        //         this.commentshow();
        //         this.loading = false
        //         this.getExperiment();
        //     }).catch(err=>{
        //         this.$notify({
        //             message:"暂无实验,我们会尽快补充,已为您跳转首页",
        //             type:'error'
        //         })
        //         this.$router.push('/')
        //     })
        // },
        //浏览量加1
        browseNum(){
                request({
                    url:'api/jdResourcesBrowseNum?'+'browseNum='+this.infoBrowseNum+'&id='+this.infoId,
                    method:'put'
                }).then(res=>{
            })
        },
        //获取到信息
        Obtaininfo(){
            request({
                method:'get',
                url:'api/jdResources/'+this.infoId+'?msg='+this.infoNumber
            }).then(res=>{
                this.infoAerage = res.data.jdresource.average
                this.infoScoringMan = res.data.jdresource.scoringMan
            })
        },
        //评论星级
        changerate(){
            request({
                url:'api/jdResourcesAverage?'+'id='+this.infoId+'&score='+this.infoAerage+'&scoringMan='+this.infoScoringMan+'&totalPoints='+this.infoTotalPoints+'&userId='+this.userid,
                method:'post'
            }).then(res=>{
                if(res.msg == '每个实验只能评分一次'){
                    this.$notify({
                        message:'抱歉，您已经评论过该实验了哦',
                        type:'error',
                        duration: 1500
                    })
                }else{
                    this.$notify({
                        message:'评论成功',
                        type:'success',
                        duration: 1500
                    })
                    this.Obtaininfo();
                }
            })
        },
        //分页
        pageChange(data){
            this.pageData.pagenumber = data-1;
            this.commentshow();
        },
        //实验意见反馈
        upfeedback(){
            let data = {}
            data.resourceid = this.infoId
            data.content=this.Feedback
            data.resourceName = this.newup.title
            // data.type =this.radio2 //意见反馈按钮选择
            data.userId = this.userid
            data=JSON.stringify(data)
            if(this.Feedback == ''){
                this.$notify({
                    message:'对不起，您的意见为空，请输入意见后提交',
                    type:'error',
                    duration: 1500
                })
            }else{
            request({
                method:"post",
                url:'/api/opinion/saveOpinion?',
                data:data
            }).then(res =>{
                if(res.code == 200){
                    this.flagb=false
                    this.$notify({
                        message:'意见反馈成功，我们会努力核实',
                        type:'success',
                        duration: 1500
                    })
                    this.Feedback = ''
                }else{
                    this.flagb=false
                    this.$notify({
                        message:'一天只能反馈一次哦！',
                        type:'error',
                        duration: 1500
                    })
                    this.Feedback = ''
                }
            })
          }
        },
        //实验评论展示
        commentshow(type){
            request({
                method:'get',
                url: 'api/jdComment/comment/searchPage?'+'page='+this.pageData.pagenumber+'&resourceid='+this.infoId+'&size='+this.pageData.pagesize+'&sort=edittime%2Cdesc'
            }).then(res=>{
                this.labshow = res.data.content;
                // for(let i in this.labshow){
                //     this.labshow[i].edittime = TimeRoles(this.labshow[i].edittime)
                // }
                var temp = {}
                temp.pagesize=this.pageData.pagesize
                temp.pagenumber=this.pageData.pagenumber
                temp.total =Number(res.data.totalElements);
                this.pageData=temp
            })
        },
        //实验评论
        onSubmit() {
            let commen = {}
            commen.avatar = this.usinfo
            commen.edittime = this.comment.edittime
            commen.fraction = this.comment.fraction
            commen.msg = this.comment.msg
            commen.username = this.$store.state.user.name
            commen.resourceid = this.infoId
            commen=JSON.stringify(commen)
            if(this.comment.msg == ''){
                this.$notify({
                    message:"对不起，评论为空，请输入文字后再提交",
                    type:"error",
                    duration: 1500
                })
            }else{
            request({
                method:"post",
                url:'/api/jdComment/comment/add',
                data:commen
            }).then(res =>{
                this.commentshow();
                this.comment.msg = ''
                this.$notify({
                    message:'评论提交成功',
                    type:'success',
                    duration: 1500
                })
            })
          }
        },
        //实验传值
        getIndex(){
            this.infoId = this.$route.query.infoId;
            this.infoTitle = this.$route.query.infoTitle
            this.infoPhoto = this.$route.query.infoPhoto
            this.infoAerage = this.$route.query.infoAerage
            this.infoScoringMan = this.$route.query.infoScoringMan
            this.infoTotalPoints = this.$route.query.infoTotalPoints
            this.infoBrowseNum = this.$route.query.infoBrowseNum
            this.infoNumber = this.$route.query.infoNumber
            this.infoTreeId = this.$route.query.infoTreeId
            this.infoNodeName = this.$route.query.infoNodeName
            this.infoIsFree = this.$route.query.infoIsFree
            this.infoSearch = this.$route.query.infoSearch
            this.infoStudy = this.$route.query.infoStudy
            this.infoisStudy = this.$route.query.infoisStudy
            if(this.infoisStudy === ''){
                if(this.infoNumber == 0){
                    this.bus.$emit('zhishidian', 0)
                    this.bus.$emit('isStudys', 1)
                }else{
                    this.bus.$emit('zhangjie', 1)
                    this.bus.$emit('isStudys', 1)
                }
            }else if(this.infoisStudy == 0 ){
                if(this.infoNumber == 0){
                    this.bus.$emit('zhishidian', 0)
                    this.bus.$emit('isStudys', 2)
                }else{
                    this.bus.$emit('zhangjie', 1)
                    this.bus.$emit('isStudys', 2)                    
                }

            }else if(this.infoisStudy == 1){
                if(this.infoNumber == 1){
                    this.bus.$emit('zhangjie', 1)
                    this.bus.$emit('isStudys', 3)
                }else{
                    this.bus.$emit('zhishidian', 0)
                    this.bus.$emit('isStudys', 3)
                }
            }
            // if(this.infoNumber = ''){
            // }else{
            //     this.infoNumber = this.$route.query.infoNumber
            //     if(this.infoNumber = ''){
            //         this.infoNumber = 0
            //     }else{
            //         this.infoNumber = this.$route.query.infoNumber
            //     }
            // }
        },
        //通过当前id获取到实验详细信息
        // getInformation(){
        //     request({
        //         methods:'get',
        //         url:'api/jdInformation/getResourceAttrById?'+'noticeLevelType='+this.infoId
        //     }).then(res =>{
        //         this.Information = res.data;
        //     })
        // },
        feedback(){
            this.flagb = true
        },
        // Opinion(){
        //     this.flago = true
        // },
        closeb(){
            this.flagb = false
            this.Feedback = ''
        },
        // closeo(){
        //     this.flago = false
        // }
    }
}
</script>

<style scoped>
    @import '../../../../node_modules/videojs-markers/dist/videojs.markers.min.css';
    @import './infopublic.css';
    @import '../../../components/styles/pad.css';
    .demo>>>.m3u8Video102-dimensions{
        width: 100%;
        height: 100%;
    }
    .demo>>>.video-js{
        width: 100%;
        height: 100%;
    }
    .demo>>>.vjs-marker{
        position: absolute;
        left: 0;
        bottom: 0em;
        opacity: 1;
        height: 100%;
        transition: opacity .2s ease;
        -webkit-transition: opacity .2s ease;
        -moz-transition: opacity .2s ease;
        z-index: 100;
    }
    .demo>>>.vjs-marker:hover{
        cursor: pointer;
        -webkit-transform: scale(1.3, 1.3);
        -moz-transform: scale(1.3, 1.3);
        -o-transform: scale(1.3, 1.3);
        -ms-transform: scale(1.3, 1.3);
        transform: scale(1.3, 1.3);
    }
    .demo>>>.vjs-tip{
        display: block;
        opacity: .8;
        padding: 5px;
        font-size: 12px;
        position: absolute;
        bottom: 14px;
        z-index: 1000000;
    }
    .demo>>>.vjs-tip .vjs-tip-inner{
        -webkit-border-radius:4px;
        padding:  5px 8px 5px 8px;
        background-color: #000;
        text-align: center;
        max-width: 200px;
        color: #fff;
        line-height: 14px;
    }
    .demo>>>.vjs-big-play-button{
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }
    .demo>>>.video-js .vjs-picture-in-picture-control{
        display: none;
    }
    #el-main-footer{
        background:none repeat scroll 0 0 white;
        border-top:1px solid #e7eaec;
        overflow:hidden;
        padding:10px 6px 0px 6px;
        font-size:0.7rem !important;
        color:#7a8b9a;
        letter-spacing:0.8px;
        font-family:Arial, sans-serif !important;
        position: fixed;
        bottom: 0;
        height: 33px;
        z-index:2000;
        width: 100%;
    }
    #closeunV{
        float:left;
        margin: 0;
        padding:5px 16px 3px 16px;
        font-size:20px;
        background: rgba(0, 0, 0, 0.2);
        text-align: center;
        color:#fff;
        z-index: 200;
        cursor: pointer;
    }
    .demo{
        display: inline-block;
        width: 100%;
        height: 100%;
        text-align: center;
        line-height: 100px;
        border-radius: 4px 0 4px 4px;
        background-color: rgba(0, 0, 0, 0.2);
        overflow: hidden;
        position: fixed;
        box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
        margin-right: 4px;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }
    .newbox{
        width: 94%;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        margin-top: 108px;
    }
    .newinfo{
        background: #f5f5f5;
        position: relative;
        width:100%;
        margin-bottom: 20px;
    }
    .el-breadcrumb /deep/ .el-breadcrumb__inner.is-link{
        font-weight: 400;
        cursor: pointer;
    }
    .info{background: #f5f5f5;height:100vh;}
    .mains{padding: 0;}
    .el-button{margin: 0 ;padding: 0;}
    .el-button>b{float: right;height: 100%;}
    .el-button--primary{float: right;width: 99px;height: 40px;background: #f0f0f0;color: #999;border: 1px solid #f0f0f0;transition:all 0.2s linear 0s;}
    /* .el-button--primary:hover{
        background-color: #f1ad4e;
        transition: all 0.2s ease 0s;
        border:1px solid #f1ad4e;
    } */
    .el-breadcrumb{
        font-size: 16px;
    }
    .el-raidom{
        margin-top: 10px;
        float: left;
        width: 150px;
    }
    .el-radio{
        float: left;
        line-height: 35px;
    }
    .el-input{
        width: 376px;
        margin-left: 20px;
    }
    .el-textarea{
        margin-top: 10px;
    }
    .el-checkbox-group{
        width: 150px;
        height: 100px;
        float: right;
    }
    .el-checkbox{
        float: left;
        margin: 5px 0;
    }
    #box{
        height:auto;/* height:1000px */
        position: relative;
    }
    .el-footer{
        padding: 0 48px;
        width: 1710px;
        position:absolute;
        left: 50%;
        transform: translateX(-50%);
        background: #fff;
    }
    .comment{height: 60px;margin-top: 32px;}
    .comment p{font-size: 18px;font-weight: bold;margin: 0;}
    .tokra{
        float: left;
        width: 300px;
        height: 18px;
        margin-top: 16px;
    }
    .chat{
        height: 220px;
    }
    .el-rate{float: left;margin-right: 20px;}
    .breakB{
        position: absolute;
        right: 0;
        top: 10px;
    }
    .brief{
        box-shadow: 0 0 12px #eee;
        position: relative;
        height: calc( (43.4vw / 16) * 9);
    }
    .noinfo{
        position: absolute;
        width: 93%;
        height: 240px;
        overflow-y: auto;
        top: 99px;
        left: 28px;
        color: #666;
        font-size: 20px;
        font-weight: normal;
        line-height: 36px;
        margin-top: -10px;
    }
    .boxs{
        width: 4px;
        height: 20px;
        background: #f1ad4e;
        position: absolute;
        top: 50px;
        left: 26px;
    }
    .infotitle2{
        position: absolute;
        top: 45px;
        left: 40px;
        font-size: 28px;
        color: #333;
        font-weight: bold;
    }
    .imginfo{
        position: relative;
        width:100%;
        height: calc( (43.4vw / 16) * 9);
    }
    .blackbox{
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translateX(-50%) translateY(-50%);
        margin: 0; 
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.2);
        transition: all 0.2s ease 0s;
    }
    /* .el-icon-switch-button{
        font-size: 130px;
    } */
    .el-icon-circle-close{
        font-size: 160px;
        color: rgba(0, 0, 0, 0.4)
    }

    .imginfo /deep/ .el-button--text{
        color: rgba(255, 255, 255, 1);
    }
    .imginfo /deep/ .el-button--text:hover{
        /* color: #f1ad4e; */
    }
    .imginfo:hover .blackbox{
        transition:all 0.2s linear 0s;
        background-color: rgba(0, 0, 0, 0.4)
    }
    .imginfo>img{
        width: 100%;
        height: 100%;
    }
/* 评论展示 */
    .commentshow{
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        margin-top: 393px;
        width: 1710px;
        padding: 0 48px;
        background: #fff;
    }
    .show{
        font-size: 18px;
        line-height: 40px;
        font-weight: normal;
    }
    .labshow{
        border-bottom: 1px solid #eee;
    }
    .labshow>dl{
        height:50px;
        margin: 8px;
        padding: 0;
        list-style: none;
    }
    .labshow>dl>dt{
        width: 50px;
        height: 50px;
        border-radius: 50%;
        border: 1px solid #888;
        float: left;
    }
    .labshow>dl>dt>img{
        width: 100%;
        height: 100%;
        border-radius: 50%;
    }
    .labshow>dl>dd:nth-of-type(1){
        padding: 5px 28px;
        font-size: 12px;
        color: #cccccc;
        font-weight: bold;
    }
    .labshow>dl>dd:nth-of-type(2){
        padding: 0 18px;
        font-size: 14px;
        height: 48px;
        line-height: 48px;
        font-weight: bold;
        color: #666;
        overflow: hidden; /* 自动隐藏文字*/
        text-overflow: ellipsis;/* 文字隐藏后添加省略号*/
       white-space: nowrap;/*  强制不换行 */
    }
    .labshow>p{
        width: 66px;
        margin: 0;
        text-align: center;
        color: #999999;
        margin-bottom: 18px;
    }
/* 分页展示 */
    .paginations{
        float: right;
        padding: 10px 0;
    }
    .tokra2{
        height: 18px;
    }
    .toke{
        float: left;
        color:#cfcfcf;
    }
    /* 提示信息 */
    .noshow{
        height: auto;
        text-align: center;
        margin-top: 100px;
        margin-bottom: 100px;
    }
    .noshow>span{
        margin-top: 19px;
        font-size: 20px;
        color: #999;
    }
    .noshow>p{
        width: 372px;
        height: 242px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
    }
    .noshow>p>img{
        width: 100%;
        height: 100%;
    }
    .newclassification{
        width: 100%;
        background: #fff;
    }
    /* 加载框 */
    .newclassification /deep/ .el-progress__text{
        color: #fff;
    }
    .newclassification /deep/ .noinfo>p:first-of-type{
        margin-top: 0;
    }
    .newclassification /deep/ .el-message{
        margin-top: 65px;
    }
    .newclassification /deep/ .el-notification{
        margin-top:65px;
    }
    .unitybox{
        width:100%;
        height: 100%;
        position: fixed;
        left: 0;
        top:0;
        bottom:0;
        right:0;
        background: rgba(0, 0, 0, 0.4);
        z-index: 4000;
    }
    .unitybox p{
        position: absolute;
        top:0;
        right:0;
        margin:0;
        background: rgba(0, 0, 0, 0.4);
        z-index: 1000;
        color:#fff;font-size:50px;
    }
    .el-form-item{
        border-bottom: none;
    }
    /* 意见反馈 */
    .feedback /deep/ .el-radio__label{
        font-size: 18px;
        color: #868686;
    }
    .feedback /deep/ .el-radio__input.is-checked+.el-radio__label{
        color: #868686
    }
    .feedback /deep/ .el-radio__input.is-checked .el-radio__inner{
        background: #f1ad4e;
        border-color: #f1ad4e;
    }
      /* tabs顶部 */
    .el-tabs /deep/ .el-tabs__header{
        background: #f0f0f0;
    }
    .el-tabs /deep/ .el-tabs__item{
        color: #999999;
        font-size: 16px;
    }
    .el-tabs /deep/ .el-tabs__item:hover{
        color: #999;
    }
    .el-tabs /deep/ .el-tabs--card>.el-tabs__header .el-tabs__nav{
        border: none;
    }
    .el-tabs /deep/ .el-tabs__item.is-active{
        color: #333333;
        font-size: 16px;
        background: #fff;
        font-weight: bold;
    }
    /* 评论框 */
    .chat /deep/ .el-form-item__content{
        border: none;
    }
    .paginations /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
        background-color: #f1ad4e;
    }
    #unitybox{
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.4);
        z-index: 2001;
    }
    #ifrunity{
        width:100%;
        height: 100%;
    }
    #buttombox{
        position: absolute;
        top: 0;
        right: -51px;
        width: 51px;
        height: auto;
    }
    #full{
        float:left;
        margin: 0;
        padding:5px 15px 3px 15px;
        font-size:20px;
        background: rgba(0, 0, 0, 0.2);
        text-align: center;
        color:#fff;
        z-index: 200;
    }
    #closeun{
        float:left;
        margin: 0;
        padding:5px 16px 3px 16px;
        font-size:20px;
        background: rgba(0, 0, 0, 0.2);
        text-align: center;
        color:#fff;
        z-index: 200;
        cursor: pointer;
        border-bottom:2px solid #eee;
    }
  @media (max-width:1024px){
    .noinfo{
        height:calc(100% - 40%);
    }
    .mains{
        margin-bottom:60px;
    }
  }
  @media screen and (min-width:1025px) and (max-width:1365px){
    .noinfo{
        height:calc(100% - 34%);
    }
    .mains{
        margin-bottom:30px;
    }
    .feedback>p{
        height: 90px;
    }
    .feedback>ul{
        margin-bottom: 20px;
    }
    .el-tabs /deep/ .circular{
        margin-top: 15px;
    }
    #box{
        height:124px;
        margin-bottom: 20px;
        position: relative;
    }
    .el-footer{
        padding: 0 48px;
        width: 94%;
        position:absolute;
        left: 50%;
        transform: translateX(-50%);
        background: #fff;
    }
    .commentshow{
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        margin-top: 345px;
        width: 94%;
        padding: 0 48px;
        background: #fff;
    }
    .unitybox p{
        position: absolute;
        top:0;
        right:0;
        margin:30px;
        margin-top: 70px;
        background: rgba(0, 0, 0, 0.4);
        z-index: 1000;
    }
    /* 提示信息 */
    .noshow{
        height: auto;
        text-align: center;
        margin-top: 100px;
        margin-bottom: 100px;
    }
    .noshow>span{
        margin-top: 14px;
        font-size: 14px;
        color: #999;
    }
    .noshow>p{
        width: 265px;
        height: 172px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
    }
    .noshow>p>img{
        width: 100%;
        height: 100%;
    }
    #bo{
        position: relative;
        left: 50%;
        top: 50%;
        right: 0;
        bottom: 0;
        transform: translateX(-50%) translateY(-50%);
        width:960px;
        height:540px;
    }
  }
  @media screen and (min-width:1366px) and (max-width:1440px){
    .feedback>p{
        height: 90px;
    }
    .feedback>ul{
        margin-bottom: 20px;
    }
    .el-tabs /deep/ .circular{
        margin-top: 15px;
    }
    #box{
        height:124px;
        margin-bottom: 20px;
        position: relative;
    }
    .el-footer{
        padding: 0 48px;
        width: 94%;
        position:absolute;
        left: 50%;
        transform: translateX(-50%);
        background: #fff;
    }
    .commentshow{
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        margin-top: 345px;
        width: 94%;
        padding: 0 48px;
        background: #fff;
    }
    .unitybox p{
        position: absolute;
        top:0;
        right:0;
        margin:30px;
        margin-top: 70px;
        background: rgba(0, 0, 0, 0.4);
        z-index: 1000;
    }
    /* 提示信息 */
    .noshow{
        height: auto;
        text-align: center;
        margin-top: 100px;
        margin-bottom: 100px;
    }
    .noshow>span{
        margin-top: 14px;
        font-size: 14px;
        color: #999;
    }
    .noshow>p{
        width: 265px;
        height: 172px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
    }
    .noshow>p>img{
        width: 100%;
        height: 100%;
    }
    #bo{
        position: relative;
        left: 50%;
        top: 50%;
        right: 0;
        bottom: 0;
        transform: translateX(-50%) translateY(-50%);
        width:960px;
        height:540px;
    }
  }
  @media screen and (min-width:1441px) and (max-width:1600px){
    #box{
        position: relative;
        height: 124px;
        margin-bottom: 20px;
    }
    .el-tabs /deep/ .circular{
        margin-top: 15px;
    }
    .el-footer{
        padding: 0 48px;
        width: 94%;
        position:absolute;
        left: 50%;
        transform: translateX(-50%);
        background: #fff;
    }
    .commentshow{
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        margin-top: 345px;
        width: 94%;
        padding: 0 48px;
        background: #fff;
    }
    .unitybox p{
        position: absolute;
        top:0;
        right:0;
        margin:30px;
        margin-top: 70px;
        background: rgba(0, 0, 0, 0.4);
        z-index: 1000;
    }
    #bo{
        position: relative;
        left: 50%;
        top: 50%;
        right: 0;
        bottom: 0;
        transform: translateX(-50%) translateY(-50%);
        width:1120px;
        height:630px;
    }
    /* 提示信息 */
    .noshow{
        height: auto;
        text-align: center;
        margin-top: 100px;
        margin-bottom: 100px;
    }
    .noshow>span{
        margin-top: 15px;
        font-size: 16px;
        color: #999;
    }
    .noshow>p{
        width: 298px;
        height: 194px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
    }
    .noshow>p>img{
        width: 100%;
        height: 100%;
    }
  }
  @media screen and (min-width:1601px) and (max-width:1920px){
    .noinfo{
        height:320px;
    }
    #box{
        height:auto;
        position: relative;
        height: 124px;
    }
    .el-footer{
        padding: 0 48px;
        width: 1710px;
        position:absolute;
        left: 50%;
        transform: translateX(-50%);
        background: #fff;
    }
    .commentshow{
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        margin-top: 345px;
        width: 1710px;
        padding: 0 48px;
        background: #fff;
    }
    .unitybox p{
        position: absolute;
        top:0;
        right:0;
        margin-right:10%;
        margin-top:100px;
        background: rgba(0, 0, 0, 0.4);
        z-index: 1000;
        color:#fff;font-size:50px;
    }
    #bo{
        position: relative;
        left: 50%;
        top: 50%;
        right: 0;
        bottom: 0;
        transform: translateX(-50%) translateY(-50%);
        width:1280px;
        height:720px;
    }
    /* 提示信息 */
    .noshow{
        height: auto;
        text-align: center;
        margin-top: 100px;
        margin-bottom: 100px;
    }
    .noshow>span{
        margin-top: 19px;
        font-size: 20px;
        color: #999;
    }
    .noshow>p{
        width: 372px;
        height: 242px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
    }
    .noshow>p>img{
        width: 100%;
        height: 100%;
    }
  }
  @media screen and (min-width:1921px) and (max-width:2048px){
    .el-tabs /deep/ .circular{
        margin-top: 15px;
    }
    .noinfo{
        height:350px;
    }
    #box{
        height:auto;
        position: relative;
        margin-top: 180px;
    }
    .el-footer{
        padding: 0 48px;
        width: 94%;
        position:absolute;
        left: 50%;
        transform: translateX(-50%);
        background: #fff;
    }
    .commentshow{
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        margin-top: 345px;
        width: 94%;
        padding: 0 48px;
        background: #fff;
    }
    .unitybox p{
        position: absolute;
        top:0;
        right:0;
        margin:30px;
        margin-top: 70px;
        background: rgba(0, 0, 0, 0.4);
        z-index: 1000;
    }
    /* 提示信息 */
    .noshow{
        height: auto;
        text-align: center;
        margin-top: 100px;
        margin-bottom: 100px;
    }
    .noshow>span{
        margin-top: 20px;
        font-size: 22px;
        color: #999;
    }
    .noshow>p{
        width: 397px;
        height: 258px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
    }
    .noshow>p>img{
        width: 100%;
        height: 100%;
    }

    #bo{
        position: relative;
        left: 50%;
        top: 50%;
        right: 0;
        bottom: 0;
        transform: translateX(-50%) translateY(-50%);
        width:1280px;
        height:720px;
    }
  }
  @media (min-width:2049px){
    .el-tabs /deep/ .circular{
        margin-top: 15px;
    }
    .noinfo{
        height:470px;
    }
    #box{
        height:auto;
        position: relative;
        margin-top: 360px;
    }
    .el-footer{
        padding: 0 48px;
        width: 94%;
        position:absolute;
        left: 50%;
        transform: translateX(-50%);
        background: #fff;
    }
    .commentshow{
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        margin-top: 345px;
        width: 94%;
        padding: 0 48px;
        background: #fff;
    }
    .unitybox p{
        position: absolute;
        top:0;
        right:0;
        margin:30px;
        margin-top: 70px;
        background: rgba(0, 0, 0, 0.4);
        z-index: 1000;
    }
    /* 提示信息 */
    .noshow{
        height: auto;
        text-align: center;
        margin-top: 100px;
        margin-bottom: 100px;
    }
    .noshow>span{
        margin-top: 25px;
        font-size: 28px;
        color: #999;
    }
    .noshow>p{
        width: 496px;
        height: 323px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
    }
    .noshow>p>img{
        width: 100%;
        height: 100%;
    }
    #bo{
        position: relative;
        left: 50%;
        top: 50%;
        right: 0;
        bottom: 0;
        transform: translateX(-50%) translateY(-50%);
        width:1760px;
        height:990px;
    }
    #el-main-footer{
      background:none repeat scroll 0 0 white;
      border-top:1px solid #e7eaec;
      overflow:hidden;
      padding:26px 6px 0px 6px;
      font-size:0.7rem !important;
      color:#7a8b9a;
      letter-spacing:0.8px;
      font-family:Arial, sans-serif !important;
      position: fixed;
      bottom: 0;
      height: 60px;
      z-index:1000;
      width: 100%;
    }
  }
</style>

<style rel="stylesheet/scss" lang="scss">
    .messageBox-prompt-test .el-button--primary{
        background-color:#f1ad4e;
        border-color:#f1ad4e;
    }
    .messageBox-prompt-test .el-button--default:hover{
        background-color:rgba($color: #f1ad4e, $alpha: 0.2);
        border-color:rgba($color: #f1ad4e, $alpha: 0.2);
        color: #f1ad4e;
    }
    .page-login-toolTipClass{
        background-color: rgba($color: #333, $alpha: 0.5) !important;
        color: #fff;
        border:none !important;
    }
    .el-tooltip__popper[x-placement^=top] .popper__arrow::after{
        border-top-color: rgba($color: #333, $alpha: 0.5) !important;
    }
    .el-tooltip__popper[x-placement^=top] .popper__arrow{
        border-top-color: rgba($color: #333, $alpha: 0.5) !important;
    }
    .el-tooltip__popper[x-placement^=right] .popper__arrow::after {
        border-right-color: rgba($color: #333, $alpha: 0.5) !important;
    }
    .el-tooltip__popper[x-placement^=right] .popper__arrow{
        border-right-color: rgba($color: #333, $alpha: 0.5) !important;
    }
</style>



// WEBPACK FOOTER //
// src/views/layout/components/BinfoS.vue